import { fetchEventsFn } from './hub'

const api = {
  fetchEvents: {
    key: 'FETCH_EVENTS',
    fn: fetchEventsFn,
  },
}

export default api
